var jQuery = require('jquery');
var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
require('bootstrap');
require('bootstrap-slider/dist/bootstrap-slider');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
// require('bootstrap/js/dist/collapse');
// require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
require('bootstrap/js/dist/tooltip');

// require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');

require('jquery.placeholder');
// require('jquery-sticky');
// require('jquery-match-height');

require('owl.carousel');
// require('magnific-popup');
// require('jquery-match-height');
// require('lazysizes');
// require('picturefill');

// require('@fortawesome/fontawesome-free');


// var elements = document.querySelectorAll('input,select,textarea');

// for (var i = elements.length; i--;) {
//     elements[i].addEventListener('invalid', function () {
//         this.scrollIntoView(false);
//     });
// }

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    

    let url = location.href.replace(/\/$/, "");

    if (location.hash) {
        const hash = url.split("#");
        $('#testimonial-tabs a[href="#' + hash[1] + '"]').tab("show");
        url = location.href.replace(/\/#/, "#");
        history.replaceState(null, null, url);
        setTimeout(() => {
            $(window).scrollTop(0);
        }, 400);
    }
    $('a[data-toggle="tab"]').on("click", function() {
        let newUrl;
        const hash = $(this).attr("href");
        if (hash == "#home") {
            newUrl = url.split("#")[0];
        } else {
            newUrl = url.split("#")[0] + hash;
        }
        newUrl += "/";
        history.replaceState(null, null, newUrl);
    });

    


    $('#btn-mob-nav, #mob-nav .nav-link').on('click', function() {
        $('#mob-nav').fadeToggle('slow');
        $('#btn-mob-nav .open-menu').toggleClass('d-block');
        $('#btn-mob-nav .close-menu').toggleClass('d-none');
        $(this).toggleClass('active');
    });

   

    $(".collapse.show").each(function() {
        $(this).prev(".card-header").find(".arrow").addClass("rotate");
        $(this).prev(".card-header").find(".read.more").hide();

    });

    // Toggle plus minus icon on show hide of collapse element
    $(".collapse").on('show.bs.collapse', function() {
        $(this).prev(".card-header").find(".arrow").addClass("rotate");
        $(this).prev(".card-header").find(".read.more").hide();

    }).on('hide.bs.collapse', function() {
        $(this).prev(".card-header").find(".arrow").removeClass("rotate");
        $(this).prev(".card-header").find(".read.more").show();
    });

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }


    // Off canvas mobile nav
    $('.btn-mobile').click(function() {
        $('.sidebar-offcanvas').toggleClass('active');
        $(this).toggleClass('close-btn')

    });

    $('select[data-toggle="tabOption"]').on('change', function(e) {
        e.preventDefault();
        let target = e.target.value;
        target = $('#' + target);
        target.addClass('active');
        target.siblings().removeClass('active');
    })


    if ($('#carousel-products').length) {
        $('#carousel-products').owlCarousel({
            responsiveRefreshRate: 1,
            margin: 50,
            responsiveClass: true,
            items: 1,
            nav: false,

            // navText : ["Prev","Next"],
            center: true,
            loop: true,
            dots: true,
            autoplay: false,
            autoplayTimeout: 5000,
            smartSpeed: 750,
            responsive: {

                0: {

                },

                576: {

                },

                768: {
                    dots: false,
                    nav: true,
                    items: 1,
                    stagePadding: 200,
                },
                1440: {
                    dots: false,
                    nav: true,
                    margin: 50,
                    stagePadding: 400,
                },

                2000: {
                    dots: false,
                    nav: true,
                    margin: 50,
                    center: true,
                    stagePadding: 600,
                },

            }

        })
    }




    if ($('#testimonial-carousel').length) {
        $('#testimonial-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: false,
            dotsEach: true,
            autoplay: true,
            autoplayTimeout: 8000,
            autoplayHoverPause:true,
            smartSpeed: 750,
            responsive: {

                768: {
                    dots: false,
                    nav: true,
                    items: 1,
                },


            },
        })
    }


    scrollToFormError();

    $(window).scroll(function() {
        if ($(this).scrollTop() > 125) {
            $('.navbar--main').addClass('page-down');
            // $('.navbar--main--brand').fadeOut();

        } else {
            $('.navbar--main').removeClass('page-down');
        }
    });

    $(window).on('load', function() {
        initFlipbook();
    });

});

// scroll window to form error element and offset fixed header height
function scrollToFormError() {
    // console.log('scrollToFormError', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#form-';
    // enquiry form error anchor offset
    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var formEl = window.location.hash;
        if ($(formEl).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());
            setTimeout(() => {
                var offsetSize = $('.navbar--main').height() + 300;
                if (windowWidth > 767) {
                    // offset
                    // animate scrollto
                    $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
                } else {
                    $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
                }
            }, 500)

        }
    }
    
}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}

function initFlipbook() {
    if ($('#flipbook').length > 0) {

        var pdf = $('#flipbook').data('src');
        var pdf_options = {
            webgl: true,
            height: "auto",
            // height: 750,
            enableDownload: false,
            scrollWheel: false,
        };
        var flipBook = $("#flipbook").flipBook(pdf, pdf_options);

        $('#brochure-tab').on('shown.bs.tab', function(e) {
            // fix hidden tab init issue
            flipBook.resize();
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js